// The backend /sports catalog is authoritative. These aliases only protect the UI
// while legacy court payloads still contain Soccer or Football.
export function normalizeSportIdentity(value: unknown): string {
  if (typeof value !== "string") return "";

  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return normalized === "football" || normalized === "soccer"
    ? "soccer"
    : normalized;
}

export function getSportDisplayName(value: unknown): string {
  if (typeof value !== "string") return "";

  const cleaned = value.trim();
  if (!cleaned) return "";
  if (normalizeSportIdentity(cleaned) === "soccer") return "Football";

  return cleaned
    .split(/[_\s-]+/g)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function sportMatchesQuery(value: unknown, query: string): boolean {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return true;
  const normalizedIdentityQuery = normalizeSportIdentity(query);

  const rawValue = typeof value === "string" ? value.trim().toLowerCase() : "";
  return (
    rawValue.includes(normalizedQuery) ||
    getSportDisplayName(value).toLowerCase().includes(normalizedQuery) ||
    (normalizedIdentityQuery.length > 0 &&
      normalizeSportIdentity(value).includes(normalizedIdentityQuery))
  );
}
